// import { createContext } from 'react';

import { createContext } from 'react';

import { ActionContext } from 'types/context';

export const ActionsContext = createContext<ActionContext | undefined>(undefined);
